<template>
<div>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>

  <base-alert-dialog
    :show="alertDialog.show"
    :variant="alertDialog.variant"
    :title="alertDialog.title"
    :message="alertDialog.message"
    :show-cancel="alertDialog.showCancel"
    :confirm-text="alertDialog.confirmText"
    :confirm-variant="alertDialog.confirmVariant"
    @confirm="onAlertConfirm"
    @cancel="alertDialog.show = false"
  />

  <!--    Breadcrumbs-->
  <breadcrumb style="margin-left: -15px">
    <breadcrumb-item>
      <a href="/settings/user-management">Users</a>
    </breadcrumb-item>
    <breadcrumb-item>
      <a href="/settings/roles">Roles</a>
    </breadcrumb-item>
    <breadcrumb-item>
      <span>{{ role.name || "Role" }}</span>
    </breadcrumb-item>
  </breadcrumb>

  <div class="row">
    <div class="col-lg-3">
      <card>
        <div class="row">
          <div class="col">
            <h4 v-if="role.hasOwnProperty('id')" class="card-title">Edit role</h4>
            <h4 v-else class="card-title">View role permissions</h4>
          </div>
          <div class="col-3 text-right" v-if="role.hasOwnProperty('id')">
            <el-dropdown>
              <base-button
                link
                type="primary"
                size="sm"
              > <i style="font-size: large" class="tim-icons el-icon-more"></i>
              </base-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <a class="dropdown-item" @click="deleteRolePrompt()" href="#">
                    <i class="tim-icons text-default icon-trash-simple mr-2"></i> Delete role
                  </a>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <div class="row" >
          <div class="col">
            <base-input :disabled="!role.hasOwnProperty('id')" v-model="role.name" placeholder="Role name" label="Name"></base-input>
            <base-input label="Description">
              <el-input :disabled="!role.hasOwnProperty('id')"
                v-model="role.description"
                :rows="5"
                type="textarea"
                placeholder="Role description"
              />
            </base-input>
            <base-input v-if="role.hasOwnProperty('id')" label="Default landing page">
              <el-select
                v-model="role.default_landing_page"
                class="select-primary"
                placeholder="Use group default"
                clearable
              >
                <el-option
                  v-for="opt in landingPageOptions"
                  class="select-primary"
                  :label="opt.label"
                  :value="opt.key"
                  :key="'LP' + opt.key"
                ></el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="role.hasOwnProperty('id')">
          <div class="col">
            <base-button v-on:click="cancel()" type="default">Cancel</base-button>
            <base-button class="ml-2" v-on:click="saveRole()" type="primary">Save</base-button>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-9">
      <card>
        <div class="row mb-3">
          <div class="col">
            <tab-rail
              :tabs="categories"
              :value="activeTabIndex"
              @input="switchTab"
            />
          </div>
        </div>
<!--        Permissions-->
        <div v-if="activeTabIndex === 0">

          <div class="row mt-3">
            <div class="col-lg-4 d-flex" v-for="(p, i) in permissions" :key="i + 'P'">
              <card class="flex-fill bordered-card d-flex flex-column">
                <h4 class="text-uppercase">
                  <i v-if="i === 0" class="tim-icons icon-chart-pie-36"></i>
                  <i v-if="i === 6" class="tim-icons icon-email-85"></i>
                  <i v-if="i === 1" class="tim-icons icon-money-coins"></i>
                  <i v-if="i === 2" class="tim-icons icon-calendar-60"></i>
                  <i v-if="i === 3" class="tim-icons icon-check-2"></i>
                  <i v-if="i === 4" class="tim-icons icon-settings-gear-63"></i>
                  <i v-if="i === 5" class="tim-icons icon-user-run"></i>
                  <i v-if="i === 7" class="tim-icons el-icon-search"></i>
                  <i v-if="i === 8" class="tim-icons icon-shape-star"></i>
                  <i v-if="i === 9" class="tim-icons el-icon-box"></i>
                  <i v-if="i === 10" class="tim-icons icon-camera-18"></i>
                  <i v-if="i === 11" class="tim-icons icon-app"></i>
                  <i v-if="i === 12" class="tim-icons icon-bag-16"></i>
                  <i v-if="i === 13" class="tim-icons icon-tap-02"></i>
                  <i v-if="i === 14" class="tim-icons icon-spaceship"></i>
                  <i v-if="i === 15" class="tim-icons icon-molecule-40"></i>
                  <i v-if="i === 16" class="tim-icons icon-pencil"></i>
                  <i v-if="i === 17" class="tim-icons el-icon-user"></i>
                  <i v-if="i === 18" class="tim-icons icon-notes"></i>
                  {{ p.parent_feature }}</h4>
                <div class="row" v-for="(pp, j) in p.items" :key="j + 'PP'">
                  <div class="col" v-if="pp.has_options === 0">
                    <el-switch :disabled="!role.hasOwnProperty('id')" active-color="#e14eca" v-model="pp.enabled" />
                    <label style="font-size: small">&nbsp;{{ pp.name }}</label>
                  </div>
                  <div class="col" v-else>
                    <base-input :label="pp.name" :disabled="!role.hasOwnProperty('id')">
                      <el-select :disabled="!role.hasOwnProperty('id')"
                        v-model="pp.enabled"
                        class="select-primary"
                        name="email_group"
                        placeholder="Email Group"
                        value-key="id"
                      >
                        <el-option
                          v-for="(a, i) in access_options"
                          class="select-primary"
                          :label="a.label"
                          :value="{id: a.id, label: a.label}"
                          :key="'A' + i"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>

<!--        Notifications-->
        <div v-if="activeTabIndex === 1">
          <div class="row mt-3">
            <div class="col-lg-4">
              <card class="flex-fill d-flex flex-column">
                <h4 class="text-uppercase">
                  <i class="tim-icons icon-send"></i>
                  Email notifications
                </h4>
                <div class="row" v-for="(n, i) in notifications" :key="i + 'N'">
                  <div class="col">
                    <el-switch active-color="#e14eca" :disabled="!role.hasOwnProperty('id')"
                               v-model="n.enabled"  />
                    <label style="font-size: small"> &nbsp; {{n.name}}</label>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</div>
</template>

<script>
import {BTable} from "bootstrap-vue";
import {Dropdown, DropdownItem, DropdownMenu, Switch} from "element-ui";
import BreadcrumbItem from "@/components/Breadcrumb/BreadcrumbItem";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import {Auth} from "aws-amplify";
import {API_LOCATION} from "@/api-config";
import axios from "axios";
import TabRail from "@/components/TabRail.vue";
import {BaseSwitch} from "@/components";
import _ from "lodash";

export default {
  name: "EditRole",
  components: {
    BTable,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Switch.name]: Switch,
    BreadcrumbItem,
    Breadcrumb,
    TabRail,
    BaseSwitch
  },
  data() {
    return {
      loading: false,
      permissions: [],
      notifications: [],
      role: '',
      activeTabIndex: 0,
      alertDialog: {
        show: false,
        variant: 'warning',
        title: '',
        message: '',
        showCancel: false,
        confirmText: 'OK',
        confirmVariant: 'primary',
        onConfirm: null,
      },
      access_options: [{id: 2, label: 'All'}, {id: 1, label: 'Only my own'}, {id: 0, label: 'No access'}],
      landingPageOptions: [
        { key: 'bookings',   label: 'Bookings' },
        { key: 'dashboard',  label: 'Dashboard' },
        { key: 'games',      label: 'Game tracker' },
        { key: 'mail',       label: 'Mail' },
        { key: 'purchases',  label: 'Purchases' },
        { key: 'projects',   label: 'Project management' },
        { key: 'customers',  label: 'Customers' },
        { key: 'waivers',    label: 'Waivers' },
        { key: 'settings',   label: 'Settings' },
      ]
    }
  },
  computed: {
    categories() {
      return [
        { name: 'Permissions' },
        { name: 'Notifications' }
      ];
    },
  },
  methods: {
    deleteRolePrompt(){
      this.alertDialog = {
        show: true,
        variant: 'warning',
        title: 'Are you sure?',
        message: 'The role will be permanently deleted. Users may lose access.',
        showCancel: true,
        confirmText: 'Delete',
        confirmVariant: 'danger',
        onConfirm: () => this.deleteRole(),
      }
    },
    showError(){
      this.alertDialog = {
        show: true,
        variant: 'danger',
        title: 'Error',
        message: 'Something went wrong',
        showCancel: false,
        confirmText: 'OK',
        confirmVariant: 'primary',
        onConfirm: null,
      }
    },
    onAlertConfirm(){
      const handler = this.alertDialog.onConfirm
      this.alertDialog.show = false
      if (handler) handler()
    },
    async deleteRole(){
      let companyId = localStorage.getItem('companyId')
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let url = API_LOCATION + 'companies/' + companyId + '/roles/' + this.role.id
      this.axios.delete(url, config)
        .then(response => {
          this.$notify({ type: 'success', message: 'The role has been deleted', icon: 'tim-icons icon-check-2' })
          this.$router.push('/settings/roles')
        })
        .catch(err => {
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showError()
          }
        })
    },
    cancel(){
      this.$router.push('/settings/roles')
    },
    filteredItems(array, type) {
      return array.filter(item => item.has_options === type);
    },
    switchTab(index){
      this.activeTabIndex = index
    },
    flattenGroupedArray(groupedArray) {
      return groupedArray.reduce((acc, group) => {
        return acc.concat(group.items);
      }, []);
    },
    groupByParentFeature(arr) {
      for(let n in arr){
        if(arr[n].has_options === 1){
          arr[n].enabled = _.find(this.access_options, {id: arr[n].enabled})
        } else {
          arr[n].enabled = Boolean(arr[n].enabled)
        }
      }

      arr.sort((a, b) => {
        if (a.has_options !== b.has_options) return a.has_options - b.has_options;
        if (a.type === 'custom_fields_configure') return -1;
        if (b.type === 'custom_fields_configure') return 1;
        return 0;
      });

      const grouped = arr.reduce((acc, item) => {
        const parentFeature = item.parent_feature;
        if (!acc[parentFeature]) {
          acc[parentFeature] = [];
        }
        acc[parentFeature].push(item);
        return acc;
      }, {});

      return Object.keys(grouped)
        .sort()
        .map(key => ({
          parent_feature: key,
          items: grouped[key]
      }));
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    async saveRole(){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let roleId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/roles/' + roleId

      let data = {
        role: this.role,
        permissions: this.flattenGroupedArray(this.permissions),
        notifications: this.notifications
      }

      axios.put(url, data, config)
        .then(response => {
          this.loading = false
          this.getRole()
          this.$notify({ type: 'success', message: 'Role has been updated', icon: 'tim-icons icon-check-2' })
        })
        .catch(err => {
          this.loading = false
          if (err.response.status == 401) {
            this.$router.push('/forbidden')
          } else {
            this.showError()
          }
        })
    },
    async getRole() {
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let roleId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/roles/' + roleId

      axios.get(url, config)
        .then(response => {
          this.loading = false
          this.role = response.data.role

          this.notifications = response.data.notifications
          for(let n in this.notifications){
            this.notifications[n].enabled = Boolean(this.notifications[n].enabled)
          }
          this.permissions = this.groupByParentFeature(response.data.permissions)

        })
        .catch(err => {
          this.loading = false
          if (err.response.status == 401) {
            this.$router.push('/forbidden')
          } else {
            this.showError()
          }
        })
    }
  },
  mounted() {
    this.getRole()
  }
}
</script>

<style scoped>
.bordered-card{
  border: 1.5px solid #e14eca;
  border-radius: .1875rem;
  min-height: 168px;
}
</style>
